<template>
  <div id="base-input">
    <input
      :type="type"
      :class="classNames"
      :required="required ? true : false"
      :placeholder="placeholder"
      :disabled="disabled"
      v-model="content"
      @input="handleInput"
    >
  </div>
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
      type: {
          type: String,
          default: "text"
      },
      placeholder: {
          type: String,
          default: ""
      },
      classNames: {
          type: String,
          default: ""
      },
      required: {
          type: Boolean,
          default: false
      },
      disabled: {
          type: Boolean,
          default: false
      },
      value: {
        type: String,
        default: ""
      }
  },
  data () {
    return {
      content: this.value
    }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', this.content)
    }
  },
};
</script>

<style lang="scss">

#base-input {
  height: 100%;

  input {text-transform: none;}
  input::-webkit-input-placeholder {text-transform: none;}
  input::-moz-placeholder {text-transform: none;}
}
</style>


// WEBPACK FOOTER //
// src/components/shared/inputs/BaseInput.vue